import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/css/main.css'
import { currency } from './commons/currency'
import { display_date, order_status, order_status_color, order_status_text_color, vip_level, vip_level_color, capitalize, display_value, display_color, display_text_color } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
import VueMuuriGrid from 'vue-muuri-grid'
import HighchartsVue from 'highcharts-vue'
import firebase from 'firebase';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import VueExcelEditor from 'vue-excel-editor';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

var VueDragula = require('vue-dragula');

try {
  const firebaseConfig = {
    apiKey: 'AIzaSyAB5H5VIzVtdhVJYgOZd2FhYUeErZQiW80',
    authDomain: 'vbimex-2022.firebaseapp.com',
    projectId: 'vbimex-2022',
    storageBucket: 'vbimex-2022.appspot.com',
    messagingSenderId: '985540889736',
    appId: '1:985540889736:web:5d8871c9da2855d5aee33d',
    measurementId: 'G-GT4HXGSHFZ'
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const messaging = firebase.messaging();
  
  messaging.usePublicVapidKey('BOgNf9bFELoQEYzUCJb-l6kH6VnQGO8kS0LfjVBCnFYPczmT-ghhn5R64dB_d9gXNqKHhXHvoipHwshTITHqoJg'); // 1. Generate a new key pair
  // Request Permission of Notifications
  messaging.requestPermission().then((permission) => {
    if (permission !== 'granted') {
      console.warn('Notification permission not granted');
    } else {
      messaging.getToken().then((token) => {
        window.localStorage.setItem('FCM_Token', JSON.stringify(token));
      });
    }
  }).catch();
} catch (error) {
  console.error('Error getting permission or token:', error);
}
Vue.use(VueResource);
Vue.use(require('vue-shortkey'))
Vue.use(VueMuuriGrid);
Vue.use(HighchartsVue);
Vue.use(VueCtkDateTimePicker);
Vue.use(VueDragula);
Vue.use(VueExcelEditor);
Vue.use(Viewer)
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('order_status', order_status)
Vue.filter('order_status_color', order_status_color)
Vue.filter('order_status_text_color', order_status_text_color)
Vue.filter('vip_level', vip_level)
Vue.filter('vip_level_color', vip_level_color)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
